export const TOOLTIPTEXT = {
  markAsPreferred: "Mark as preferred",
  markAsUnsuitable: "Mark as unsuitable",
  removeStatus: "Remove status",
  resendInvite: "Resend invite",
  resendEmailToClientUser: "Resend Login Instruction",
  approve: "Approve",
  reject: "Reject",
  authorise: "Authorise",
  amend: "Amend",
  filter: "Filter",
  download: "Download",
  invoiceDownload: "Invoice Download",
  bulkDownload: "Bulk Download",
  export: "Export",
  notifications: "Notifications",
  help: "Help",
  view: "View",
  edit: "Edit",
  add: "Add",
  apply: "Apply",
  update: "Update",
  discard: "Discard",
  signOff: "Sign Off",
  securityCode:
    "The Code is used to sign off locum timesheets. Please click this button if you require a new security code.",
  bulkUpload: "Bulk Upload",
  delete: "Delete",
  print: "Print",
  refresh: "Refresh",
  contractView: "Contracts",
  shiftView: "Shifts",
  addrolecancel: "Close",
  editrolecancel: "Close",
  editTemplate: "Edit Template",
  primaryContact: "Transfer Ownership",
  viewAppliedDates: "View Proposed Dates",
  viewAppliedCalender: "Proposed Calendar",
  editManageShifts: "Edit Contract",
  selectManegeOneDate: "Please select a date to add shifts",
  inactiverole:
    "The branches are either removed or not configured properly. Please provide branch access to activate the role. Users assigned an inactive role will be unable to log in.",
  checkadminRole: "You can't edit or delete Admin role",
  checkOwnRole: "You can't edit or delete your own role",
  checkPrimaryContact: "You can't edit or delete Primary contact person",
  checkOwnUser: "You can't edit or delete your own user",
  mergeContract: "Merge Contract",
  time: "Time period",
  statusChange: "Change Status",
  announcement: "Announcement",
  downloadingInvoice:
    "Invoice(s) is being generated and will be available under Download Menu.",
  publishForApplocum: "Contract publish to AppLocum",
  changeNoSetDurationOfBankContract: "Set a new bank contract duration",
  updateCandidatePayStatus: "Mark as Paid",
  reminderToUploadCompliance: "Reminder to upload compliance",
  overrideCandidateCompliance: "Override this candidate compliance",
  removeOverrideCandidateCompliance:
    "Remove Override this candidate compliance",

  publishForApplocum: "Contract publish to AppLocum",
  changeNoSetDurationOfBankContract: "Set a new bank contract duration",
  autoApproveCandidate: "Auto-Approve Candidate",
  removeApproveCandidate: "Remove Auto-Approve Candidate",
  changeNoSetDurationOfBankContract: "Set a new bank contract duration",
  candidateMarkAsAutoApproved: "This Candidate marked as auto-approved",
  addShifts: "Add Shift",
  editShifts: "Edit Shift",
  deleteShifts: "Delete Shift",
  archive: "Archive",
  expandCalendar: "Expand Calendar",
  viewAllUpcomingShifts: "View All",
  deleteBroadcast: "Delete Broadcast",
  removeCandidate: "Remove Candidate",
  addCandidate: "Add Candidate",
  removeBroadCastInfoCandidate:
    "You can't remove this candidate because it has only one candidate left in broadcast.",
  broadCastSetting: "Broadcast Settings",
  sendMessage: "Send Message",
  bankContract: "Bank Contract",
  appLocumContract: "AppLocum Contract",
  dayRateBasicInfo:
    "Day Rate functionality allows you to set a fixed rate for the entire day instead of setting by the hour.",
  Expand: "Expand",
  Collapse: "Collapse",
};

export const toastMessageText = {
  downloading: "Downloading....",
  downloadSuccess: "Downloaded successfully",
  exportOnGoing: "Your export will be ready shortly",
  downloadInvoiceOnGoing: "Your Invoice will be downloaded shortly",

  // actions
  noCandidateSelected: "Please select candidate",
  noTimesheetSelected: "Please select timesheet",
  onlyOneCandidateSelected: "Please select one candidate",
  selectOneCandidateToEdit: "Please select one candidate to edit",
  onlyOneUnfilledContractSelected: "Please select one contract",
  onlyOneContractSelected: "Please select one contract to manage shifts",

  selectUnregisteredCandidate: "Please select Unregistered candidate",
  selectregisteredCandidate: "Please select registered candidate",

  onlyRegisteredShortlistnandUnsuitable:
    "Only Registered Candidates can be shortlisted or unsuitable",
  cannotApproveMultipleCandidateForSingleContract:
    "You can not approve single contract for multiple candidates",
  cannotApproveAllCandidate: "You can not approve all contracts",
  selectFileToUpload: "Please select a file to upload",
  uploadOnlyZipFile: "Please upload only .zip file",
  uploadOnlyXlsFile: "Please upload only .xls or .xlsx file",
  emptyExportMessageForContract: "Please select contract to export",
  emptyExportMessageForCandidate: "Please select candidate to export",
  deleteUnfillesContracts: "Please select contract to archive",
  deleteUnfillesCandidate: "Please select candidate to delete",

  deleteBankContracts: "Please select job rate to delete",
  // compliance actions
  selectDocumentToView: "Please select document to view",
  selectOneDocumentToView: "Please select only one document to view",
  noDocumentAvailable: "Document not available",
  selectDocumentToDownload: "Please select document to download",
  maxDocumentDownload: "Please select 10 or less documents to download",
  documentDownloaded: "Documents Downloaded successfully",
  downloadDocumentInDownloadSection:
    "Compliance Document(s) is being generated and will be available under Download Menu.",

  // invoice actions
  selectInvoiceToDownload: "Please select invoice to download",
  maxInvoiceDownload: "Please select 16 or less invoices to download",

  // Timesheet AmendMent Form
  minSessionRequired: "Minimum 30 minutes Session require!!",
  unitNotEqualToTimeDiff:
    "Units doesn't match with start time and end time difference",
  oneunitfordayrate: "Please enter 1 unit for day rate",
  oneRecordToAmend: "Please select only one record to amend",
  oneRecordToSignOff: "Please select only one record to Sign Off",

  // Profile
  noAddressFoundForPostCode: "No address found for this postcode",
  ukPostCodeOnly: "Invalid Postcode, Enter UK Post codes only!",
  unableToConnect: "Unable to connect to server",
  postCodeRequired: "Please enter a postcode",
  unfilledBankPublishContractToAppLocum:
    "Please select one bank contract to publish to AppLocum candidate",
  checkUnfilledBankContractOrNot: "Please select only the bank contract",
  checkBankContractHasSetTimerOrNot:
    "Please select a bank contract to set a new duration period",
  unfilledBankPublishContractChangeDuration:
    "Please one Bank contract to change duration",
  // merge contract

  selectOneContractToMerge: "Please select one contract to merge",
  otherContractToMerge:
    "Please select other contracts with the same candidate and role to merge",
  selectUpToFiveContractToMerge:
    "Please select up to 5 contracts with same candidate and role to merge",
  validContractToMegerdOrNot:
    "Please select contracts with the same candidate and role to merge",
  endTimeValidation: "End Time cannot be before Start Time.",
  startEndTimeDifference:
    "End Time must be at least 30 minutes after Start Time",
  resetStartTimeValidation:
    "End Time has been reset because it must be at least 30 minutes after Start Time.",
  compliacneNotUploadedDownload:
    "Bulk Download not available because compliance is not uploaded ",
  alreadyRegWithAppLocum: "This candidate is already registered with AppLocum",
  oneCandidateMessage: "Please add atleast one candidate to send message",
  alreadySetTimeForBankContract:
    "This Bank contract's already set time for publish to AppLocum candidates.you can't update time again.",
  fetchingData: "Please wait while we're fetching the data",
  noFutureShiftForSignoff:
    "Timesheet submission is not allowed for future shifts. Please submit the timesheet after the shift has been completed.",

  nothingToClear: (payName) => {
    return `There's nothing to reset because the "${payName}" row has no data entered.`;
  },
  alreadyLoginInBranch: (client_name) => {
    return `You're currently logged into the ${client_name} branch.You can't login into the same branch again.`;
  },
  chatNameRequired: (name) => {
    return `Please enter ${name} name`;
  },
};

export const createJobValidations = {
  // form validations
  roleId: "Job Role is Required",
  jobTitle: "Job Title is Required",
  jobDesc: "Job Description is Required",
  skills: "Please select at least one skill",
  startDate: "Start Date is Required",
  endDate: "End Date is Required",

  // error messages
  emptyFields: "Time Cannot be Empty",
  isFetchingRates: "Please wait while we are fetching the rates",
  emptyShifts: "Shifts aren't valid",
  inValidUnit: "Shifts can't be of less than 30 minutes",
  maxBreakTime: "Break Time should be less than the shift time",
  fillFormAgain: "Please fill the form again as rate has been updated !",
  inValidTimeFormat: "Invalid Time Format",
  enterValidTimeFormat: "Time Format should be HH:MM",

  // job shift table action message
  selectJobShift: "Please select job shift",
  selectAllFields:
    "Please select start date, end date, start time and end time",
  shiftDeleted: "Job shift deleted successfully",

  // Date Recurrence
  selectStartDate: "Please select start date",
  selectEndDate: "Please select end date",
  selectDateRange: "Please select date range",

  // Rate Validation
  noRatesFound: "No rates found",
};

export const roleAccessValidation = {
  // form validations
  roleName: "Role name is required",
  roleDescription: "Role description is required",
  branchId: "Branch access is required",
  loginBranchId: "Branch is required",
};

export const bankJobRateValidation = {
  roleName: "Role is required",
  roleDescription: "Description is required",
  dayPayRate: "Pay rate is required when days are specified",
  dayEndTime: "End time is required when days are specified",
  dayStartTime: "Start time is required when days are specified",
  endTimePayRate: "Pay rate is required if end time is set",
  endTimeDays: "Days is required if end time is set",
  endTimeStartTime: "Start Time is required if end time is set",
  payCustomName: "Name is required",
  payDays: "Days is required",
  payStartTime: "Start Time is required",
  payEndTime: "End Time is required",
  startTimePayRate: "Pay rate is required ",
  startTimeDays: "Days is required if start time is set",
  startTimeBeforeEndTime: "Start time must be before end time",
  minimum30minutes: "Minimum 30 minutes is required between Start and End time",
  onePayDayTime: "One Standard Pay, Days and Time range detail is required",
  onePayDayForDayRate: "One Standard Pay, Days is required",
};
